const NAMESPACE = 'GOOGLE_DATA';

const SET_PREDICTIONS = `${NAMESPACE}/SET_PREDICTIONS`;
const SET_PLACE_DETAILS = `${NAMESPACE}/SET_PLACE_DETAILS`;

export {
    SET_PLACE_DETAILS,
    SET_PREDICTIONS,
};

export default NAMESPACE;
